import React from 'react';
import { ReactComponent as DivirodLogo } from './logos/divirod.svg';

import { ReactComponent as InstagramLogo } from './logos/instagram.svg';
import { ReactComponent as LinkedInLogo } from './logos/linkedin.svg';
import { ReactComponent as YouTubeLogo } from './logos/youtube.svg';
import { useSessionContext } from './SessionContext';

function SocialLink({ url, Icon }) {
  return (
    <a
      style={{ height: '24px' }}
      href={url}
      target="_blank"
      rel="noreferrer"
      aria-label={url}
    >
      <Icon style={{ height: '24px', fill: 'var(--gray0)' }} />
    </a>
  );
}

export default function LogoPanel() {
  const { setShowDisclaimerModal } = useSessionContext();
  return (

    <div className="logo-panel">
      <a
        className="frosted"
        aria-label="Divirod Website"
        href="https://divirod.com"
        target="_blank"
        rel="noreferrer"
        style={{
          marginBottom: '4px',
          padding: '8px',
          height: '48px',
          display: 'flex'
        }}
      >
        <DivirodLogo style={{ height: '48px', margin: 'auto' }} />
      </a>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          className="frosted"
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            flex: 1,
            height: '32px',
            gap: '4px',
            padding: '0px 4px'
          }}
        >
          <SocialLink url="https://www.instagram.com/divirod_inc" Icon={InstagramLogo} />
          <SocialLink url="https://www.linkedin.com/company/divirod" Icon={LinkedInLogo} />
          <SocialLink url="https://www.youtube.com/channel/UC4NdnLAXmUWpR37w3b_g3PA" Icon={YouTubeLogo} />
        </div>
        <div
          className="frosted"
          style={{
            color: 'var(--gray1)',
            fontSize: '12px',
            marginLeft: '4px',
            padding: '4px',
            fontWeight: 'bold',
            lineHeight: '24px',
            display: 'flex'
          }}
        >
          <span
            style={{ padding: '0px 4px', cursor: 'pointer' }}
            onClick={() => window.open('https://www.divirod.com/privacy-policy-1', '_blank').focus()}
          >
            Privacy
          </span>
          <span>&bull;</span>
          <span
            type="button"
            style={{ padding: '0px 4px', cursor: 'pointer' }}
            onClick={() => setShowDisclaimerModal(true)}
          >
            Disclaimer
          </span>
        </div>
      </div>
    </div>
  );
}
